module.exports = __webpack_public_path__ + "img/FIL.6bf4ab03.svg";